import React from "react";
import { Badge } from "@chakra-ui/react";

const CLASSIFICATION_CONFIG = {
  strength: { label: "Strength", colorScheme: "green" },
  development: { label: "Development", colorScheme: "orange" },
  neutral: { label: "Neutral", colorScheme: "gray" },
};

const FactorClassificationBadge = ({ classification }) => {
  const config = CLASSIFICATION_CONFIG[classification] || CLASSIFICATION_CONFIG.neutral;

  return <Badge colorScheme={config.colorScheme}>{config.label}</Badge>;
};

export default FactorClassificationBadge;
